import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { Base64 } from 'js-base64';
import { getValues } from '@dbk-legacy/muster/utils';
import startOfToday from 'date-fns/start_of_today';
import startOfYesterday from 'date-fns/start_of_yesterday';
import { addDays, ymd } from '../utils/date';
import isValidJsonString from '../utils/is-valid-json-string';
import Guid from '../utils/guid';

export default () => {
  const today = startOfToday();
  const yesterday = startOfYesterday();
  const past7Days = addDays(-6, yesterday);
  const past30Days = addDays(-30, yesterday);
  const past3Months = new Date(
    yesterday.getFullYear(),
    yesterday.getMonth() - 3,
    yesterday.getDate()
  );

  return muster()
    .path('cashAccounts.bookingList', {
      call: async ({ req }, { get, set }) => {
        try {
          await set('cashAccounts.isLoading', true);
          const [destinationCcy, portfolioData, fromDate, endDate, positionObjId, bookingDateType] = await getValues(get([
            'userprofile.prefCurrency',
            'app.user.selectedPortfolioData',
            'cashAccounts.fromDate',
            'cashAccounts.endDate',
            'cashAccounts.positionObjId',
            'cashAccounts.bookingDateType'
          ]));

          const request = {
            destinationCcy: destinationCcy || portfolioData.referenceCurrency,
            relId: portfolioData.relId || portfolioData.title,
            relIdType: portfolioData.relIdType,
            positionObjId,
          };
        
          const inputParam = Base64.encode(JSON.stringify(request));
          const guidStr = Guid();
          const [cashAccList] = await getValues(get(`roster.data.cashAccounts.getRTCashAccList["${inputParam}"]["${guidStr}"]`));

          isValidJsonString(cashAccList).then(async (data) => {
            if (data && data.cashAccList && data.cashAccList.length > 0) {
              await set('cashAccounts.cashAccountData', data.cashAccList[0]);
              const requestBookings = {
                balance: data.cashAccList[0].balance,
                pfId: data.cashAccList[0].pfId,
                fromDate,
                endDate,
                positionObjId,
                bookingDateType,
              };
              const bookingParam = Base64.encode(JSON.stringify(requestBookings));
              const [cashAccountBookings] = await getValues(get(`roster.data.cashAccounts.bookingList["${bookingParam}"]["${guidStr}"]`));

              isValidJsonString(cashAccountBookings).then(async (bookings) => {
                if (bookings) {
                  await set('cashAccounts.bookings', bookings);
                  await set('cashAccounts.bookingsHasMore', bookings.hasMore);
                  await set('cashAccounts.isLoading', false);
                }
              }).catch((error) => set('cashAccounts.isLoading', false))
            } else { await set('cashAccounts.isLoading', false); }
          }).catch((error) => set('cashAccounts.isLoading', false))
        } catch (error) { await set('cashAccounts.isLoading', false) }
      }
    })
    .path('cashAccounts.setRange7Days', {
      call: async ({ req }, { set }) => {
        await set('cashAccounts.isLoading', true);
        await set('cashAccounts.fromDate', ymd(past7Days));
      },
    })

    .path('cashAccounts.setRange30Days', {
      call: async ({ req }, { set }) => {
        await set('cashAccounts.isLoading', true);
        await set('cashAccounts.fromDate', ymd(past30Days));
      },
    })

    .path('cashAccounts.setRange3Months', {
      call: async ({ req }, { set }) => {
        await set('cashAccounts.isLoading', true);
        await set('cashAccounts.fromDate', ymd(past3Months));
      },
    })

    .path('cashAccounts.setFromDate', {
      call: async ({ req }, { set }) => {
        const { fromDate } = req.args[0];
        await set('cashAccounts.isLoading', true);
        await set('cashAccounts.fromDate', ymd(fromDate));
      },
    })
    .path('cashAccounts.setBookingDateType', { 
      call: async ({ req }, { set }) => {
        const { bookingDateType } = req.args[0];
        if(bookingDateType){
        await set('cashAccounts.bookingDateType', bookingDateType);
        }
      },
    })
    .path('cashAccounts.getRTCashAccList', {
      call: async ({ req }, { get, set, call }) => {
        await set('cashAccounts.showSpinner', true);
        const [destinationCcy, portfolioData] = await getValues(get(['auth.destinationCurrency', 'app.user.selectedPortfolioData']));
        await set('cashAccounts.destinationCcy', (destinationCcy || portfolioData.referenceCurrency));
        const request = {
          destinationCcy: destinationCcy || portfolioData.referenceCurrency,
          relId: portfolioData.relId || portfolioData.title,
          relIdType: portfolioData.relIdType,
          positionObjId: req.args[0] || null
        };
        const guidStr = Guid();
        const inputParam = Base64.encode(JSON.stringify(request));
        const [oReturn] = await getValues(get(`roster.data.cashAccounts.getRTCashAccList["${inputParam}"]["${guidStr}"]`));

        isValidJsonString(oReturn).then(async (data) => {
          if (data) {
            await set('cashAccounts.cashAccSummary', data);
          }
          else {
            await set('cashAccounts.serverError', true);
          }
        }).catch(async () => {
          await set('cashAccounts.serverError', true);
        })
        await set('cashAccounts.showSpinner', false);
      }
    })

    .path('cashAccounts.cashAccountData', variable({}))
    .path('cashAccounts.bookings', variable({}))
    .path('cashAccounts.fromDate', variable(ymd(past7Days)))
    .path('cashAccounts.endDate', variable(ymd(today)))
    .path('cashAccounts.positionObjId', variable(null))
    .path('cashAccounts.isLoading', variable(false))
    .path('cashAccounts.showSpinner', variable(false))
    .path('cashAccounts.bookingsHasMore', variable(false))
    .path('cashAccounts.serverError', variable(false))
    .path('cashAccounts.cashAccSummary', variable(null))
    .path('cashAccounts.destinationCcy', variable(null))
    .path('cashAccounts.bookingDateType',variable(''));
}